import { Model as s } from "../../../model.js";
class t extends s {
  constructor(o) {
    super(), this.images = o.images, this.colors = o.colors, this.fontFamily = o.fontFamily;
  }
}
export {
  t as CheckoutDesignModel
};
//# sourceMappingURL=design.model.js.map
